export default __webpack_public_path__ + "static/sayless-logo-c02dece3b2702408bc8b75ed96ebdf39.png";